import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { PDF_COMPRESS_PARAMS_MEDIUM } from "../app.constants";

@Component({
  selector: "app-dialog-report-complete-confirm",
  styleUrls: ["./inspection-report-complete-confirm-dialog.component.scss"],
  templateUrl: "./inspection-report-complete-confirm-dialog.component.html",
  standalone: false
})
export class ReportCompleteConfirmDialogComponent implements OnInit {
  public isLargePdf = false;
  private totalImageLimitForWarning = 100;

  constructor(
    private dialogRef: MatDialogRef<ReportCompleteConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {
    if (this.data.totalImagesInReport > this.totalImageLimitForWarning && this.data.finalReportQuality <= PDF_COMPRESS_PARAMS_MEDIUM.KEY) {
      this.isLargePdf = true;
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
